export default "__VITE_ASSET__BBJTg8YH__"